import axios from "axios";
import { gnov } from "flowy-3-core";
import config from "../config";

/**
 * Search approved curp in the server
 *
 * @param {string} curp curp we're searching for
 * @returns
 */
async function searchCurp(curp: string) {
  const fid = "q15";
  const formId = "69dddd7cf19c0a001c9f51e0";
  const filter = `{{${fid}}} == "${curp}" AND ({{status}} != "s1" AND {{status}} != "s9")`;
  const searchUrl = `${config.apiUrl}/main_api/v1/public/search/root_gizmo/data/${formId}`;

  try {
    const response = await axios({
      method: "post",
      url: searchUrl,
      data: {
        filter,
      },
    });

    if (response.status === 200) {
      const { filledForms } = response.data;

      if (filledForms.length > 0) {
        const rootGizmoDataFid = gnov(filledForms[0], `filledFormId`);
        const downloadUrl = `${config.apiUrl}/public/forms/${formId}/filled_forms/pdf/${rootGizmoDataFid}?pdfFolio=foro_beneficiario26`;
        const downloadManifestUrl = `${config.apiUrl}/public/forms/${formId}/filled_forms/pdf/${rootGizmoDataFid}?pdfFolio=manifiesto_26`;

        return { downloadUrl, downloadManifestUrl };
      }
    }
  } catch (e) {
    console.log("eeeeeeeeeerror: ", e);
  }
}

export default searchCurp;
